export default __webpack_public_path__ + "static/media/bin.5ca74e36.svg";